const outcomes = [
  {
    num: "₹6–12L",
    h: "Cash recovered per store",
    p: "Within the first 60 days of acting on clearance and stop-buying recommendations.",
  },
  {
    num: "2.3×",
    h: "Inventory turnover improvement",
    p: "Stores using Stock Move see significantly faster stock rotation within two buying cycles.",
  },
  {
    num: "40%",
    h: "Reduction in panic discounting",
    p: "When you identify slow movers early, you have time to clear at better margins instead of fire-sale pricing.",
  },
  {
    num: "Zero",
    h: "Surprise dead stock",
    p: "Catch categories drifting toward dead stock before they become a problem, not after.",
  },
  {
    num: "1 hour",
    h: "From upload to decision",
    p: "Get a full inventory health report and action list within an hour of uploading your data.",
  },
  {
    num: "Every month",
    h: "Smarter buying decisions",
    p: "Use last month's movement data to inform next month's purchase orders. No more gut-feel buying.",
  },
];

export default function OutcomesSection() {
  return (
    <div className="sm-section-full sm-section-bg" id="outcomes">
      <div className="sm-section">
        <div className="sm-reveal">
          <span className="sm-eyebrow">Outcomes</span>
          <h2 className="sm-h2">
            Real numbers from
            <br />
            real retail businesses
          </h2>
          <p className="sm-h2-sub">
            What store owners experience after using Stock Move consistently for
            one buying cycle.
          </p>
        </div>

        <div className="sm-outcomes-grid">
          {outcomes.map((outcome, index) => (
            <div
              key={index}
              className={`sm-outcome-card sm-reveal sm-reveal-d${(index % 3) + 1}`}
            >
              <div className="sm-outcome-num">{outcome.num}</div>
              <h3 className="sm-outcome-h3">{outcome.h}</h3>
              <p className="sm-outcome-p">{outcome.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}